import { layoutPadding } from '@/core/constants/class-names'
import { cn } from '@/core/lib/utils/cn'
import { CustomerHeader } from '@/core/ui/header'
import { BannerModel } from '@/features/content/types/models/banner-model'
import { BannerContent } from './banner-content'

function StaticHeader() {
  return (
    <CustomerHeader
      showNav
      theme='red'
      className={cn(layoutPadding, 'bg-transparent py-2 shadow-none')}
    />
  )
}

function FixedHeader() {
  return (
    <CustomerHeader
      showNav
      theme='blue'
      shadow
      className={cn(
        layoutPadding,
        'animate-delay-0 animate-ease animate-fade-down animate-duration-200 fixed rounded-b-sm py-2',
      )}
    />
  )
}

type Props = {
  slides: BannerModel[]
  form: React.ReactNode
  textShadow?: boolean
}

export const Banner: React.FC<Props> = async ({ slides, form, textShadow }) => {
  return (
    <BannerContent
      staticHeader={<StaticHeader />}
      fixedHeader={<FixedHeader />}
      bannerSlides={slides}
      form={form}
      textShadow={textShadow}
    />
  )
}
